import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle password reset logic here
    console.log('Password reset requested for:', email);
    setSubmitted(true);
  };

  return (
    <div className="forgot-password-page">
      <section className="auth-content">
        <div className="container">
          <div className="auth-card">
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <h1 style={{ fontSize: '2.5rem', color: '#d32f2f', marginBottom: '0.5rem' }}>Reset Your Password</h1>
              <p style={{ color: '#666', fontSize: '1.05rem' }}>
                Enter your email address and we'll send you instructions to reset your password.
              </p>
            </div>
            {submitted ? (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h2>Check Your Email</h2>
                <p>
                  We've sent password reset instructions to <strong>{email}</strong>. 
                  Please check your inbox and follow the link to reset your password.
                </p>
                <p className="help-text">
                  Didn't receive the email? Check your spam folder or{' '}
                  <button onClick={() => setSubmitted(false)} className="link-button">
                    try again
                  </button>
                  .
                </p>
                <Link to="/my-account" className="btn btn-primary">
                  Back to Sign In
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>

                <button type="submit" className="btn btn-primary btn-large">
                  Send Reset Instructions
                </button>

                <div className="auth-links">
                  <Link to="/my-account">Back to Sign In</Link>
                  <Link to="/sign-up">Don't have an account? Sign up</Link>
                </div>
              </form>
            )}

            <div className="auth-help">
              <h4>Need Immediate Assistance?</h4>
              <p>
                Call our Member Care team at <strong>1-877-579-9862</strong> and we'll help you 
                regain access to your account.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;

